'use strict';

/* Controllers */

app.controller('TicketedEventSelectTicketsController', ['$scope', '$rootScope', 'User', 'Braintree', 'Helper', 'Preloader', 
    'Popup', 'Payment', '$location', '$timeout', '$routeParams', 'TicketedEvent',
    function ($scope, $rootScope, User, Braintree, Helper, Preloader, Popup, Payment, $location, $timeout, $routeParams, TicketedEvent) {

        $scope.slug = $routeParams.event_name || null;
        TicketedEvent.get($scope.slug, function(resp){
            if (!resp.data.success) {
                Popup.error('Something went wrong :(', function () {
                    $location.path('/');
                });
            } else {
                // save event to root globals
                $rootScope.globals.ticketedEvent = resp.data;
                $rootScope.globals.ticketedEvent.event.slug = $scope.slug;

                // return back if there is no data in root global variable
                if( typeof $rootScope.globals.ticketedEvent == 'undefined' ){
                    $location.path('/event');
                }

                // Get facebook meta
                if( typeof $rootScope.globals.ticketedEvent.event !== 'undefined' ){
                    $rootScope.facebookMeta = Helper.getFacebookMetaData($rootScope.globals.ticketedEvent.event);
                }

                $rootScope.redirectUrl = Helper.getRedirectUrl();
                $rootScope.waave_url = Helper.getWaaveUrl();

                // pass service to scope
                $scope.User = User;

                // set application flow
                $rootScope.globals.flow = 'ticketing';

                // setup partials
                $scope.partials = {
                    payment_methods     :   'views/ticketed_event/partials/payment-methods.html',
                    credit_card_payment :   'views/ticketed_event/partials/credit-card-payment.html',
                    message             :   'views/ticketed_event/partials/message.html',
                };

                // init vars
                var paypal_checkout = null;

                // init scope vars
                $scope.processing_payment       = false;
                $scope.getting_token            = true;
                $scope.purchase_complete        = false;
                $scope.currency_symbol          = $rootScope.globals.currentUser.credit.symbol;
                $scope.slug                     = $routeParams.event_name;
                $scope.partial                  = $scope.partials.payment_methods;
                $scope.tickets                  = $rootScope.globals.ticketedEvent.tickets;
                $scope.subtotal                 = 0;
                $scope.processing_fee           = 0;
                $scope.total                    = 0;
                $scope.totalInNumber            = 0;
                $scope.tickets_count            = 0;

                // run on page init
                initBraintreeForPaypalPayment();
                calculateCart();

            }
        });
        

        /**
         * function that is run when user clicks on
         * pay with waave credit button
         */
        $scope.payWithWaaveCredit = function() {
            // save data to storage
            Helper.updateLocalStorageWithGlobalVariable();

            $scope.processing_payment = true;

            // make payment
            Payment.make('waave_credit', 'ticket', function(resp, status){

                if( status == 200 ){
                    // success, show success message to user
                    $scope.purchase_complete = true;
                    $scope.partial = $scope.partials.message;
                }
                else{
                    // check for errors
                    switch(status){
                        case 402:
                            Popup.error('You need additional WAAVE credits to complete this purchase.');
                            break;

                        case 404:
                            Popup.error('Event does not exist.', function(){
                                window.location.href = 'http://getwaave.com';
                            });
                            break;

                        case 403:
                            Popup.error(resp.data.message, function(){
                                window.location.href = '/tickets/' + $rootScope.globals.ticketedEvent.event.slug;
                            });
                            break;

                        case 400:
                            Popup.error('Sorry, this payment method is not supported.');
                            break;

                        case 401: break; // invalid token

                        default:
                            Popup.error('Something went wrong :(');
                            break;
                    }
                }

                $scope.processing_payment = false;
            });
        }


    	/**
    	 * function that is run when user clicks on
    	 * pay with PayPal button
    	 */
    	$scope.payWithPayPal = function(paypal_object) {
            
            // if clicked first init paypal,
            if( typeof paypal_object == 'undefined' ){
                paypal_checkout.paypal.initAuthFlow();
                return;
            }

            // this will run next time this function
            // is called with paypal_object
            
            // save paypal_object in $rootScope
            $rootScope.braintree = {
                paypal_object: paypal_object
            };

    		// save data to storage
    		Helper.updateLocalStorageWithGlobalVariable();

    		$scope.processing_payment = true;

    		// make payment
    		Payment.make('paypal', 'ticket', function(resp, status){

    			if( status == 200 ){
    				// success, show success message to user
                    $scope.purchase_complete = true;
    				$scope.partial = $scope.partials.message;
    			}
    			else{
    				// check for errors
	    			switch(status){
                        case 404:
                            Popup.error('Event does not exist.', function(){
                                window.location.href = 'http://getwaave.com';
                            });
                            break;

                        case 403:
                            Popup.error(resp.data.message, function(){
                                window.location.href = '/tickets/' + $rootScope.globals.ticketedEvent.event.slug;
                            });
                            break;

                        case 400:
                            Popup.error('Sorry, this payment method is not supported.');
                            break;

                        case 401: break; // invalid token

                        default:
                            Popup.error('Something went wrong :(');
                            break;
	    			}
    			}

    			$scope.processing_payment = false;
    		});
    	}

        /**
         * init braintree on page load
         */
        function initBraintreeForPaypalPayment(){

            Braintree.getToken(function(token, status){

                // check status code
                if( status != 200) {
                    Popup.error("Couldn't get token, PayPal and Credit Card option will be disabled.");
                    return;
                }

                // init braintree to get nonce
                braintree.setup(token, 'custom', {
                    paypal: {
                        singleUse: false, 
                        amount: $scope.totalInNumber,
                        currency: 'SGD', 
                        locale: 'en_us', 
                        headless: true,
			billingAgreementDescription: 'Use this account for future payment.', 
                    },
                    onPaymentMethodReceived: function (obj) {
                        $scope.payWithPayPal(obj);
                    },
                    onReady: function (integration) {
                        paypal_checkout = integration;

                        // braintree is initialized, enable payment buttons
                        $scope.$apply(function(){
                            $scope.getting_token = false;
                        });
                    },
                });
            });

        }

        /**
         * function that is run when user clicks on
         * pay with Credit Card button
         */
        $scope.payWithCreditCard = function(){
            
            $scope.getting_token = true;

            // show credit card partial
            $scope.partial = $scope.partials.credit_card_payment;

            // When you are ready to tear down your integration
            paypal_checkout.teardown(function () {
                paypal_checkout = null;
                // braintree.setup can safely be run again!
            });

            // waith 1 second, maybe partial with credit card form will not be loaded as fast
            $timeout(function(){
                initBraintreeForCreditCardPayment();
            }, 1000);
        }



        /**
         * disable submit button on click
         */
        $scope.submitCreditCardForm = function(){
            $scope.processing_payment = true;
        }


        /**
         * init payment with credit card
         */
        function initCreditCardPayment(credit_card_object) {

            // save credit_card_object in $rootScope
            $rootScope.braintree = {
                credit_card_object: credit_card_object
            };


    		// make payment
    		Payment.make('credit_card', 'ticket', function(resp, status){

    			if( status == 200 ){
    				// success, show success message to user
                    $scope.purchase_complete = true;
    				$scope.partial = $scope.partials.message;
    			}
    			else{
    				// check for errors
                    switch(status){
                        case 400:
                            Popup.error('Sorry, this payment method is not supported.');
                            break;

                        case 404:
                            Popup.error('Event does not exist.', function(){
                                window.location.href = 'http://getwaave.com';
                            });
                            break;

                        case 403:
                            Popup.error(resp.data.message, function(){
                                window.location.href = '/tickets/' + $rootScope.globals.ticketedEvent.event.slug;
                            });
                            break;

                        case 401: break; // invalid token

                        default:
                            Popup.error('Something went wrong :(');
                            break;
                    }
    			}

    			$scope.processing_payment = false;
    		});
    	}


        /**
         * init braintree on page load
         */
        function initBraintreeForCreditCardPayment(){

            Braintree.getToken(function(token, status){

                // check status code
                if( status != 200) {
                    Popup.error("Couldn't get token, PayPal and Credit Card option will be disabled.");
                    return;
                }

                // init braintree to get nonce
                braintree.setup(token, 'custom', {
                    id: "credit-card-form",
                    hostedFields: {
                        styles: {
                            'input': {
                                'font-family': 'Helvetica, Arial, sans-serif',
                                'font-size': '22px',
                            },
                            ':focus'  : { 'color': '#1e1e1e' },
                            '.valid'  : { 'color': '#1e1e1e' },
                            '.invalid': { 'color': '#F3564B' },
                        },
                        number: { 
                            selector: "#card-number", 
                            placeholder: 'CC Number', 
                        },
                        cvv: { 
                            selector: "#cvv", 
                            placeholder: 'CVV', 
                        },
                        expirationDate: { 
                            selector: "#expiration-date", 
                            placeholder: 'Exp (mm/yy)', 
                        },
                        onFieldEvent: function(event) {
                            // add credit card icon
                            iconType = document.getElementsByClassName("icon-type")[0];
                            iconType.className = "icon-type";
                            if(event.card) iconType.className += " icon-type-" + event.card.type;
                        }
                    },
                    onPaymentMethodReceived: function (obj) {
                        // passed validation, submit payment
                        $scope.processing_payment = true;
                        initCreditCardPayment(obj);
                    },
                    onReady: function (integration) {
                        // braintree is initialized, enable submit button
                        $scope.$apply(function(){
                            $scope.getting_token = false;
                        });
                    },
                    onError: function (payload) {
                        if( payload.type == 'SERVER' ){
                            Popup.error(payload.message);
                        }else if( payload.type == 'VALIDATION' ){
                            Popup.error(payload.message);
                        }else{
                            Popup.error('Payment service did not respond, please try again in a few minutes.');
                        }
                        $scope.processing_payment = false;

                        $scope.$apply();
                    },
                });
            });

        }



        /**
         * decrement ticket count
         * @param  object ticket
         */
        $scope.decrementTicketCount = function(ticket){
            if( $scope.purchase_complete ) return;

            if( ticket.count > 0 ){
                ticket.count -= 1;
                calculateCart();
            }
        }

        /**
         * increment ticket count
         * @param  object ticket
         */
        $scope.incrementTicketCount = function(ticket){
            if( $scope.purchase_complete ) return;

                // validate ticket sale limit
            if (checkTicketSaleLimit(ticket)) {
                ticket.count += 1;
                calculateCart();
            } 
        }


        /**
         * calculate cart
         */
        function calculateCart(){
            var subtotal       = 0;
            var processing_fee = 0;

            $scope.tickets_count = 0;

            angular.forEach($scope.tickets, function(ticket) {
                subtotal       += ticket.price * ticket.count;
                processing_fee += ticket.fee * ticket.count;

                $scope.tickets_count += ticket.count;
            });

            // Card #963:
            $scope.totalInNumber          = Helper.roundNumber(subtotal+processing_fee, 2);
            // End Card #963
            
            // Card 806: Multi-Currency / Multi-Gateway Feature
            var decimalCount = $rootScope.globals.ticketedEvent.venue[0].format_currency[0];
            var decimal = $rootScope.globals.ticketedEvent.venue[0].format_currency[1];
            var thousands = $rootScope.globals.ticketedEvent.venue[0].format_currency[2];            
            $scope.subtotal       = Helper.formatCurrency(subtotal, decimalCount, decimal, thousands);
            $scope.processing_fee = Helper.formatCurrency(processing_fee, decimalCount, decimal, thousands);
            $scope.total          = Helper.formatCurrency(subtotal+processing_fee, decimalCount, decimal, thousands);
            // End card 806: Multi-Currency / Multi-Gateway Feature

            Helper.updateLocalStorageWithGlobalVariable();
        }

        /**
         * check ticket sale limit
         */
        function checkTicketSaleLimit(ticket){
            var new_value = ticket.count + 1;
            if (ticket.sale_limit !== null && ticket.sold + new_value > ticket.sale_limit) {
                // show error
                Popup.error(TICKET_SALE_LIMIT_ERROR + ticket.name);
                return false;
            }

            return true;
        }

        /**
         * watcher for processing_payment variable
         */
        $scope.$watchGroup(['processing_payment', 'getting_token'], function() {
            if( $scope.processing_payment || $scope.getting_token ){
                Preloader.open();
            }else{
                Preloader.close();
            }
        });

        /**
         * Check to show button Waace cerdit or not
         * @return boolean
         */
        $scope.showBtnWaaveCredit = function() {
            var result = true;
            var forEachLoop = true;

            if ($rootScope.globals.credits && $rootScope.globals.ticketedEvent) {
                angular.forEach($rootScope.globals.credits, function(wallet) {
                    if (wallet.currency_code == $rootScope.globals.ticketedEvent.venue[0].currency
                        && wallet.credit > 0
                        && forEachLoop) {
                        result = false;
                        forEachLoop = false;
                    }
                });
            }

            return result;
        };
    }]);
